
import { Options, prop, Vue } from "vue-class-component";

class Props {
  isDisabledBookingBtn = prop<boolean>({
    default: false,
    type: Boolean
  });
  isDisabledSearchFlightBtn = prop<boolean>({
    default: false,
    type: Boolean
  });
  isShowSearchFlightBtn = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({})
class CreateCargoNonRTCLayout extends Vue.with(Props) {}
export default CreateCargoNonRTCLayout;
